import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { StawavScheduledRideInput } from '@/models/scheduledRide';

export const getStaWavScheduledRideEstimation = async (data: StawavScheduledRideInput) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      data,
    },
    query: graphql(`
      query GetStaWavScheduledRideEstimation($data: StawavScheduledRideInputType!) {
        getStaWavScheduledRideEstimation(data: $data) {
          wheelchairTransportationRate
          wheelchairTransportationStandardRate
          wheelchairTransportationSurchargeRate
          passengerTransportationRate
          passengerTransportationStandardRate
          passengerTransportationSurchargeRate
          waitTimeRate
        }
      }
    `),
  });

  return response.data.getStaWavScheduledRideEstimation;
};
